import { StandardEvents } from '@shopify/events';

class FeltWhimsySelectionSummary extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const blockId = this.dataset.blockId;
        if (!blockId) return;

        const updatedSummary = detail.html.querySelector(
          `feltwhimsy-selection-summary[data-block-id="${CSS.escape(blockId)}"]`
        );
        if (!(updatedSummary instanceof HTMLElement)) return;

        this.innerHTML = updatedSummary.innerHTML;
        if (detail.newProduct?.id) this.dataset.productId = detail.newProduct.id;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[feltwhimsy-selection-summary] Variant update failed:', error);
        }
      });
  };
}

if (!customElements.get('feltwhimsy-selection-summary')) {
  customElements.define('feltwhimsy-selection-summary', FeltWhimsySelectionSummary);
}
